import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

const win: any = window;
const ready: Promise<void> = win.$app?.bootstrapReady ?? Promise.resolve();
ready.then(() => {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
});
